import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-product-storage-dialog',
  templateUrl: './product-storage-dialog.component.html',
})
export class ProductStorageDialogComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
